import * as THREE from 'three';

export abstract class Model {
    protected name: string;
    protected viewer: any;
    protected model: any | null;

    constructor(name, viewer, model = null) {
        this.name = name;
        this.viewer = viewer;
        this.model = model;
    }

    init() {
        if (this.model == null) throw new Error('Model is null');

        this.model.name = this.name;
        this.viewer.scene.add(this.model);
    }

    abstract animate(delta);

    dispose() {
        this.viewer.scene.remove(this.model);

        switch (this.model.type) {
            case 'Group':
                this.model.traverse((object) => {
                    this.disposeMesh(object);
                    this.viewer.log(`Dispose group: ${this.model.name}, ${this.model.type}`);
                });
                break;
            case 'Mesh':
                this.disposeMesh(this.model);
                this.viewer.log(`Dispose mesh: ${this.model.name}, ${this.model.type}`);
                break;
            case 'PointLight':
            case 'DirectionalLight':
                this.model.dispose();
                this.viewer.log(`Dispose lights: ${this.model.name}, ${this.model.type}`);
                break;
            default:
                this.viewer.log(`Dispose others: ${this.model.name}, ${this.model.type}`);
        }

        this.model = null;
    }

    // eslint-disable-next-line class-methods-use-this
    disposeTextures(material: THREE.Material): void {
        material.map?.dispose();
        material.aoMap?.dispose();
        material.normalMap?.dispose();
        material.lightMap?.dispose();
        material.emissiveMap?.dispose();
        material.roughnessMap?.dispose();
        material.displacementMap?.dispose();
        material.metalnessMap?.dispose();
        material.alphaMap?.dispose();
        material.bumpMap?.dispose();
        material.envMap?.dispose();
    }

    disposeMesh(mesh): void {
        if (mesh.geometry) {
            mesh.geometry.dispose();
        }

        if (mesh.material) {
            if (mesh.material.length) {
                for (let i = 0; i < mesh.material.length; i++) {
                    this.disposeTextures(mesh.material[i]);
                    mesh.material[i].dispose();
                }
            } else {
                this.disposeTextures(mesh.material);
                mesh.material.dispose();
            }
        }
    }
}
